import { GET_EVENTS_LIST, SET_EVENT_TYPES } from '../actionTypes';

export default function (state = {
  eventTypes: [],
  eventPlanList: [],
}, actions) {
  switch (actions.type) {
	  case SET_EVENT_TYPES: {
	 	return {
	 		...state,
		  eventTypes: actions.payload,
	  };
	 }
	  case GET_EVENTS_LIST: {
	  	return {
	  		...state,
			  eventPlanList: actions.payload,
		  };
	  }
	  default: {
	  	return state;
	  }
  }
}
